export const pt = {
  hanab: "Hanab",
  welcome: "Bem vindo(a)",
  newGame: "Novo jogo",
  tagline: "Jogue Hanab online com amigos!",
  subTagline: "Jogo de cartas cooperativo disponível no celular, tablet & desktop",
  createRoom: "Criar uma sala",
  joinRoom: "Entrar em uma sala",
  rejoinGame: "Reentrar no jogo",
  whatsHanab: "O quê é Hanab?",
  invitationByPlayers: "{{playersNames}} esta te convidando para um jogo de Hanab 🎉",
  invitationByPlayers_plural: "{{playerNames}} estão te convidando para um jogo de Hanab 🎉",
  invitationNoPlayers: "Você está sendo convidado para um jogo de Hanab 🎉",
  gameFull: "Todos estão aqui!",
  gameNotFull: "{{count}} / {{playersCount}} já entrou",
  gameNotFull_plural: "{{count}} / {{playersCount}} já entraram",
  startGame: "Começar jogo",
  addAi: "+ adicionar AI",
  lobby: "Lobby",
  choosePlayerName: "Escolha o seu nome de jogador",
  join: "Entrar",
  autoplay: "Autoplay",
  shareGame: "Compartilhe esse jogo",
  copy: "Copiar",
  waitForOthers: "Espere pelos outros, ou ",
  gameStarted: "Jogo começou!",
  gameStarts: "Jogo começa!",
  discardPile: "descarte ({{ discardLength }})",
  preventLossContent: "Você fez besteira · Continua?",
  rewind: "🕑 Voltar",
  backToGame: "Voltar ao jogo",
  theirTurn: "É a vez de {{currentPlayerName}}!",
  go: "Vamos!",
  estimatedMaxScore: "Pontuação máxima estimada para essa mesa: {{reachableScore}}.",
  keepPracticing: "Continue praticando",
  congrats: "Muito bem!",
  hideStats: "Esconder estatísticas",
  showStats: "Mostrar estatísticas",
  gameOver: "O jogo acabou! • A sua pontuação é {{playedCardsLength}} 🎉",
  score: "Hanab • Pontuação: {{score}} / {{maxPossibleScore}}",
  turnsLeftDisclaimer: "· 1 turno restante",
  turnsLeftDisclaimer_plural: "· {{count}} turnos restantes",
  cardLeft: "{{pileLength}} restantes",
  tokens: "fichas",
  deck: "deck",
  loading: "Carregando...",
  menu: "Menu",
  tutorial: "Tutorial",
  rules: "Regras",
  yourTurn: "Sua vez",
  youWillStart: "Você vai começar",
  hide: "Ocultar",
  reveal: "Revelar",
  cardSelected: "Carta {{position}} selecionada",
  eightTokens: "8 fichas",
  cannotDiscard: "Você não pode descartar",
  noTokens: "Sem fichas para dar dica",
  selectVignette: "Selecione uma cor ou um número para dar dica",
  hint: "Dica",
  negativeHintColor: "Você não tem carta {{ color }}",
  negativeHintNumber: "Você não tem {{ number }}s",
  positiveHintColor: "Sua carta {{ positions }} é {{ color }}",
  positiveHintNumber: "Sua carta {{ positions }} é um {{ number }}",
  positiveHintNumberSequence: "A sua carta {{ positions }} é um {{ number }} ou maior",
  positiveHintColor_plural: "Suas cartas {{ positions }} são {{ color }}",
  positiveHintNumber_plural: "Suas cartas {{ positions }} são {{ number }}s",
  positiveHintNumberSequence_plural: "Suas cartas {{ positions }} são {{ number }}s ou maiores",
  you: "Você",
  hinted: "Deu dica",
  played: "Jogou",
  discarded: "Descartou",
  rollback: "Refazer",
  rollbackDisclaimer: "Você está prestes a refazer a sua última ação!",
  cannotRollback: "Você não pode retroceder o jogo",
  abort: "Abortar",
  introTutorial: "Tutorial",
  introContent: "Vamos aprender como jogar!",
  playedCardsTutorial: "Cartas Jogadas",
  playedCardsTutorialContent:
    "Aqui vão ficar as cartas que foram jogadas.\nColetivamente, alcancem 5 em cada cor para ganhar o jogo.",
  discardTutorial: "Descarte",
  discardTutorialContent:
    "Aqui você vai ver as cartas\nque você e o seu time descartaram.\nTente não descartar as cartas\nque vocês precisam para ganhar o jogo.",
  yourGameTutorial: "Seu jogo",
  yourGameTutorialContent:
    "Essas são as suas cartas.\nVocê não consegue ver elas, mas outros jogadores vão te dar dicas sobre elas.",
  teammatesTutorial: "Companheiros de time",
  teammatesTutorialContent:
    "Esses são os seus companheiros de time.\nComo você, eles não conseguem ver as respectivas cartas.\nDê dicas para ajudar eles a jogar ou descartar cartas.",
  hintTokensTutorial: "Fichas de dicas",
  hintTokensTutorialContent:
    "Algumas ações têm um custo.\n\n- Dar dica custa uma ficha de dica.\n- Descartando uma carta vocês ganham uma ficha de dica.\n- Jogando um 5 ganham uma ficha de dica como bônus.",
  strikeTokensTutorial: "Ficha de penalidade",
  strikeTokensTutorialContent:
    "Ao jogar uma carta errada, ela é descartada e te custa uma ficha de penalidade.\nSe chegarem a 3 fichas de penalidade, perdem o jogo.",
  yourTurnTutorial: "É a sua vez",
  yourTurnTutorialContent:
    "Você tem 3 opções:\n\n- Clique o seu jogo para jogar uma carta...\n- ... ou descartar ela\n- Clique um dos seus companheiros para dar uma dica.",
  skip: "✕ Pular",
  offline: "Você está offline !",
  apologies: "Desculpe, alguma coisa deu errado 😕",
  errorWillInvestigate:
    "Vamos investigar o mais rápido possível. Não exite em <1>nos contactar</1> com detalhes do que aconteceu.",
  earlyDevelopment: "Esse jogo ainda está em desenvolvimento e apreciamos muito o seu feedback.",
  publicRepo: "Também temos um <1>repositório público no Github </1>se você quiser contribuir ou reportar um bug.",
  backMenu: "Voltar ao menu",
  landingImageAlt: "Logo do jogo de cartas online Hanab",
  classicVariant: "Clássico",
  orangeVariant: "Laranja",
  multicolorVariant: "Multicolor",
  rainbowVariant: "Arco-íris",
  criticalRainbowVariant: "Arco-íris crítico",
  sequenceVariant: "Sequência",
  classicVariantDescription: "Um jogo clássico de Hanab com 5 cores",
  multicolorVariantDescription: "É adicionado um sexto naipe com apenas uma carta de cada número",
  rainbowVariantDescription: "É adicionado um sexto naipe que combina com todas as cores",
  criticalRainbowVariantDescription: "Arco-íris, mas o sexto naipe tem apenas uma carta de cada número",
  orangeVariantDescription: "É adicionado um sexto naipe clássico",
  sequenceVariantDescription: "Dica de números também incluem cartas de números maiores",
  showDirectHints: "Mostar dicas diretas",
  hideDirectHints: "Não mostrar dicas diretas",
  botSpeed: "Velocidade do robô",
  normalGameExplanation: "Você vai conseguir jogar online compartilhando o link do jogo com seus amigos.",
  passandplayExplanation:
    "Nesse modo 'passe e jogue', você pode jogar offline com pessoas que estão fisicamente no mesmo lugar que você, passando o aparelho para cada pessoa no turno delas.",
  private: "Privado",
  hints: "Dicas",
  allowRollback: "Permitir refazer",
  preventLoss: "Prevenir perda",
  passandplay: "Passe & Jogue",
  passandplaySubtext: "Fisicamente passe o aparelho para cada jogador no seu turno",
  privateSubtext: "O seu jogo não será visível na seção 'Entrar em uma sala'",
  advancedOptions: "Opções avançadas",
  players: "Jogadores",
  mode: "Modo",
  seed: "Seed",
  objective: "Objetivo",
  rulesIntro:
    "Hanab é um jogo de cartas criado por Antoine Bauza. É cooperativo, o que significa que os jogadores não competem com outros, mas tentam alcançar um objetivo comum. Aqui eles encarnam pirotécnicos distraídos que - por inatenção - misturaram a pólvora, pavís e foguetes para uma grande demonstração de fogos de artifício. O show vai começar logo e a situação é um pouco caótica. Eles vão precisar ajudar uns aos outros para prevenir que o show se torne um desastre.",
  rulesGoal:
    "O objetivo dos pirotécnicos é construir 5 fogos de artifício, um de cada cor (branco, vermelho, azul, amarelo, verde) combinando cartas de valor crescente (1,2,3,4,5) da mesma cor.",
  rulesSetupTitle: "Configuração",
  rulesSetup:
    "O app arruma tudo para você, o que ajuda 😉. No começo de um jogo, você vai ter 8 fichas azuis - suas fichas de dica - e 3 fichas vermelhas - suas fichas de penalidade.\n\nO baralho é composto de 50 cartas, 10 de cada cor <1>com os números 1, 1, 1, 2, 2, 3, 3, 4, 4, 5</1>.\n· Em um jogo com 2 ou 3 jogadores, cada jogador recebe 5 cartas\n· Em um jogo de 4 ou 5 jogadores, cada jogador recebe 4 cartas.\n\nComo você vai ver, não é permitido aos jogadores ver as próprias cartas!",
  rulesGameTitle: "Jogando",
  rulesGame:
    "No turno de cada jogador, eles fazer uma (e somente uma) das três ações seguintes. Não é permitido passar a vez.\n\n1. Dar informação a um outro jogador.\n2. Descartar uma carta.\n3. Jogar uma carta\n\nNão é permitido aos jogadores dar dicas ou sugestões durante o turno de outros jogadores!",
  rulesHintTitle: "1. Dar informação",
  rulesHint:
    "Quando você der uma informação, uma ficha azul é removida. Nota: Se você não tem mais fichas azuis, você não pode dar uma informação e deve fazer uma ação diferente.\n\nVocê então da uma informação a um outro jogador sobre as cartas na respectiva mão clicando nela. Você informa ao jogador sobre uma (e somente uma) cor, ou um (e somente um) valor de carta.",
  rulesDiscardTitle: "2. Descartar uma carta",
  rulesDiscard:
    "Ao descartar uma carta, você ganha uma ficha azul. Você descarta uma carta da sua mão clicando nela. Você então compra uma carta nova do baralho e ela vai para a sua mão. \nNota: Se você já tiver todas as 8 fichas azuis, você não pode descartar e deve fazer outra ação. \nVocê pode consultar as cartas descartadas a qualquer hora.",
  rulesPlayTitle: "3. Jogar uma carta",
  rulesPlay:
    "No seu turno, para jogar uma carta, tira a carta da sua mão e jogue.\nUma de duas coisas vai acontecer:\n· Se uma carta começa ou adiciona a um fogo de artifício, ela vai ser adicionada à pilha desse fogo de artifício\n· Se a carta não adiciona a um fogo de artifício, ela vai ser descartada e você ganha uma ficha de penalidade vermelha\nVocê então compra uma carta do baralho.\n\nQuando um jogador acaba um fogo de artifício jogando um 5 nele, você ganha uma ficha azul como bônus. Se você já tem as 8 fichas azuis, você não ganha o bônus.",
  rulesEndTitle: "Fim do jogo",
  rulesEnd:
    "Hanab de 3 jeitos distintos:\n· Se você ganhar uma terceira ficha vermelha, você perde o jogo e o show acaba em chamas!\n· Se o time completar todas as cinco cores de fogos de artifício com o valor de 5, o time faz uma demonstração vitoriosa e ganha a pontuação máxima de 25 pontos - 30 com a opção multicolor!\n· Se um jogador comprar a última carta do baralho, o jogo está quase no fim. Cada jogador ganha mais um turno, incluindo o jogador que comprou a última carta. Os jogadores não podem comprar mais cartas nesses turnos finais.\n\nOs jogadores então ganham pontos baseados na demonstração de fogos de artifício que construíram.",
  rulesExtensionTitle: "Extensão",
  rulesExtensionMulticolor:
    "🎨 A variação multicolor adiciona uma sexta pilha e um sexta cor de cartas com só uma carta de cada: 1, 2, 3, 4, 5. Esses fogos de artifício são então mais escassos e você vai ter que ter cuidado de não descartar eles. As regras são as mesmas e você vai ter que completar todas as 6 pilhas para receber a pontuação máxima de 30 pontos.",
  rulesExtensionRainbow:
    "🌈 A variação de arco-íris também adiciona uma sexta pilha com os mesmos valores das outras 5 pilhas (três 1s, duas cartas de 2/3/4 e um 5). A diferença é que essas cartas arco-íris são cartas de todas as cores. Toda vez que você der uma dica de cor, elas vão ser mostradas.",
  rulesUsTitle: "Quem somos nós?",
  rulesUs:
    "Nós somos um grupo de fanáticos por jogos de tabuleiro. Presos em casa em 2020, nós queríamos achar uma alternativa para jogar juntos remotamente.\nComo nós nos divertimos escrevendo código e jogando Hanab, nós decidimos criar uma versão online (e também para celulares) do jogo.\n\n👉 Como nós, por favor compre a <2>versão física</2> para ajudar os criadores se você gostar do jogo!",
  rulesContact: "✉️ <1>Nos contate</1> se você tiver alguma pergunta ou sugestão.",
  rulesContributeRepo: "💻 Nós também temos um <1>repositório público no Github</1> se você quiser contribuir.",
  rulesDiscordServer: "🗣Entre no nosso servidor de Discord para discutir melhoria",
  rulesBuymeacoffee:
    "🙇‍♀️ Você também pode ajudar a nossa iniciativa e ajudar com os custos do servidor nos comprando um café.",
  noRoom: "Sem salas disponíveis",
  faster: "Mais rápido",
  fast: "Rapido",
  slow: "Devagar",
  discard: "Descartar",
  play: "Jogar",
  green: "verde",
  red: "vermelha",
  yellow: "amarela",
  blue: "azul",
  white: "branca",
  multicolor: "multicolor",
  orange: "laranja",
  green_plural: "verdes",
  red_plural: "vermelhas",
  yellow_plural: "amarelas",
  blue_plural: "azuis",
  white_plural: "brancas",
  multicolor_plural: "multicolores",
  orange_plural: "laranjas",
  summary: "Resumo",
  summarySubtitle: "Nosso jogo de Hanab",
  gameCompleted: "Jogo completado em {{ gameDuration }}",
  result: "Nosso resultado",
  evolution: "Evolução",
  evolutionSubtext:
    "Acompanhe a história do jogo! As cartas de cada jogador mostram se são jogáveis, descartáveis ou perigosas (uma carta que se for descartada diminui a sua pontuação máxima possível, por ex. uma multicolor ou um 5).",
  playerActions: "Média de ações por jogador",
  playHints: "Média de jogadas por dica: <1>{{playsPerHint}}</1>",
  playerHints: "Quem deu mais dicas?",
  tryOutTitle: "Tente!",
  tryOutButton: "Tentar essa mesa",
  tryOutAlternative: "Você pode também jogar com outras configurações ou com nosso AI em <1>hanab.cards</1>",
  back: "Voltar",
  statsPlayable: "jogável",
  statsDiscardable: "descartável",
  statsDangerous: "perigoso",
  statsTurnCard: "Naquele turno, a carta foi",
  statsTurnAction: "Açoẽs do jogador naquele turno",
  showInsights: "Mostrar insights",
  showCards: "Mostrar cartas",
  started: "começado",
  youGaveHintTurn: "Você deu dica para <1></1> sobre o seus <3></3>",
  youDiscardedTurn: "Você descartou <1></1>",
  youPlayedTurn: "Você jogou <1></1>",
  somebodyHintedYouTurn: "<0></0> deu dica para você sobre <2></2>",
  somebodyHintedSomebodyTurn: "<0></0> deu dica para <2></2> sobre <4></4>",
  somebodyDiscardedTurn: "<0></0> descartou <2></2>",
  somebodyPlayedTurn: "<0></0> jogou <2></2>",
  whatYouDrewTurn: "e comprou <1></1>",
  whatTheyDrewTurn: "e comprou <1></1>",
  selectLanguage: "Selecione uma língua",
  creatingGame: "Criando jogo...",
  partySetup: "Jogadores: {{players}} · Modo: {{variant}} · Mesa #{{shuffle}}",
  sendMessagePlaceholder: "Mande uma mensagem para os seus companheiros",
  sendMessage: "Mandar",
  message: "<0></0>: <1></1>",
  colorBlindMode: "Modo daltónico",
  colorBlindModeSubtext: "Mostrar símbolos em cima dos cartões para ajudar a distinguir as cores",
  contributeLanguage: "Contribua!",
  buymeacoffeePostGame: "Apoie o jogo, <2>compre um café para nós</2>",
  next: "Próximo",
  new: "Novo",
  learnHanab: "Aprenda",
  learnHanabEnglish: "Esta secção está em desenvolvimento e ainda não foi traduzida para todas as línguas.",
  learnHanabTime: "~5 mn",
  learnWhileWaiting: "Aprender as noções básicas de Hanab enquanto espera",
};
